import React, { useEffect, useRef } from "react";
import { Chart } from "chart.js/auto";
import { modelAGF } from "../hooks/useModel";

const UsnComparisonChart = ({
  square,
  rentalRate,
  loanAmount,
  interestRate,
  loanPeriod,
  checkbox,
  keyRate,
}) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    const areas = [];
    const usn6 = [];
    const usn15 = [];

    for (let s = 700; s <= 2500; s += 100) {
      areas.push(s);
      const m = modelAGF(
        s,
        rentalRate,
        loanAmount,
        interestRate / 100,
        loanPeriod,
        checkbox,
        keyRate,
      );
      // Средние налоги в год по вариантам (уже в рублях)
      usn6.push(m.meanTaxes_6 || 0);
      usn15.push(m.meanTaxes_15 || 0);
    }

    if (chartInstance.current) chartInstance.current.destroy();

    chartInstance.current = new Chart(chartRef.current, {
      type: "line",
      data: {
        labels: areas,
        datasets: [
          {
            label: "Доходы * 6%",
            data: usn6,
            borderColor: "black",
            borderWidth: 3,
            fill: false,
            tension: 0.4,
            pointRadius: 0,
          },
          {
            label: "(Доходы - расходы)*15%",
            data: usn15,
            borderColor: "grey",
            borderWidth: 3,
            fill: false,
            tension: 0.4,
            pointRadius: 0,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          title: {
            display: true,
            text: "Сравнение вариантов налогообложения (УСН)",
            font: {
              family: "Montserrat, sans-serif",
              size: 16,
              weight: "bold",
            },
          },
          legend: {
            position: "bottom",
            labels: { font: { family: "Montserrat, sans-serif", size: 10 } },
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: "Средняя сумма налогов в год (период 7 лет)",
            },
            ticks: {
              callback: (val) => val.toLocaleString("ru-RU"),
            },
          },
          x: {
            title: { display: true, text: "Площадь помещения, м²" },
          },
        },
      },
    });

    return () => {
      if (chartInstance.current) chartInstance.current.destroy();
    };
  }, [
    square,
    rentalRate,
    loanAmount,
    interestRate,
    loanPeriod,
    checkbox,
    keyRate,
  ]);

  return (
    <canvas ref={chartRef} style={{ width: "100%", maxHeight: "400px" }} />
  );
};

export default UsnComparisonChart;
